import b from "./util/net.js";
import ue from "./models/braze-event.js";
import s from "./common/event-logger.js";
import { randomInclusive as tt } from "./util/math.js";
import t from "./models/request-result.js";
import r from "../shared-lib/braze-shared-lib.js";
import { STORAGE_KEYS as o } from "./managers/storage-manager.js";
import u from "./managers/subscription-manager.js";
import dt from "./Push/utils/push-utils.js";
export default class Rt {
  constructor(t, s, i, e, n, l, h, o, r, a) {
    (this._r = t),
      (this.Uo = s),
      (this.kl = 0),
      (this.yl = h.Pa()),
      (this.jl = null),
      (this.j = i),
      (this.Ur = e),
      (this.v = n),
      (this.gt = l),
      (this.h = h),
      (this.Go = r),
      (this.vt = a),
      (this.$l = o),
      (this.Al = new u()),
      (this.Cl = 50);
  }
  Tl(t, s) {
    return !t && !s && this.Go.Wn() >= this.Cl;
  }
  _l(t) {
    let s = this.j.Ch();
    if (t.length > 0) {
      const i = this.v.getUserId();
      for (const e of t) {
        const t = (!e.userId && !i) || e.userId === i;
        e.type === r.A.yh && t && (s = !0);
      }
    }
    return s;
  }
  ql(t, s, i, e, n, l, h) {
    null == i && (i = !0), i && this.Fl();
    const u = this.h.Ua(),
      a = this.h.Ba();
    let c = !1;
    const d = (t, s) => {
        let h = !1;
        b.Hs({
          url: this.Uo + "/data/",
          data: t,
          headers: s,
          S: i => {
            null != t.respond_with &&
              t.respond_with.triggers &&
              (this.kl = Math.max(this.kl - 1, 0)),
              this.vt.Os(t, i, s)
                ? (this.Go.Qs(),
                  this.gt.al(i),
                  (null != t.respond_with &&
                    t.respond_with.user_id != this.v.getUserId()) ||
                    (null != t.device && this.h.B(o.q.Xo, t.device),
                    null != t.sdk_metadata &&
                      (this.h.B(o.q.oa, t.sdk_metadata),
                      this.h.B(o.q.ua, this.j.ha())),
                    this.$l(i),
                    "function" == typeof e && e()))
                : i.auth_error && (h = !0);
          },
          error: () => {
            null != t.respond_with &&
              t.respond_with.triggers &&
              (this.kl = Math.max(this.kl - 1, 0)),
              this.vt.ca(t.events, t.attributes),
              "function" == typeof n && n();
          },
          wi: t => {
            if (("function" == typeof l && l(t), i && !c)) {
              if (t && !h) this.Dl();
              else {
                let t = this.jl;
                (null == t || t < 1e3 * this.yl) && (t = 1e3 * this.yl),
                  this.Dl(Math.min(3e5, tt(1e3 * this.yl, 3 * t)));
              }
              c = !0;
            }
          }
        });
      },
      f = this._l(u),
      m = s || f;
    if (this.Tl(h, f))
      return void r.D.info(
        "Declining to flush data due to 50 consecutive authentication failures"
      );
    if (i && !this.vt.ba(u, a, t, m))
      return this.Dl(), void ("function" == typeof l && l(!0));
    const g = this.vt.ga(t, m, u, a);
    m && this.kl++;
    let p = !1;
    if (g)
      for (const t of g)
        this.vt.Gs(t.requestData, () => d(t.requestData, t.headers)), (p = !0);
    this.Go.Jn() && i && !p
      ? this.Dl()
      : f && (r.D.info("Invoking new session subscriptions"), this.Al.St());
  }
  Ll() {
    return this.kl > 0;
  }
  Dl(t) {
    this.Pl ||
      (null == t && (t = 1e3 * this.yl),
      this.Fl(),
      (this.Rl = setTimeout(() => {
        if (document.hidden) {
          const t = "visibilitychange",
            s = () => {
              document.hidden ||
                (document.removeEventListener(t, s, !1), this.ql());
            };
          document.addEventListener(t, s, !1);
        } else this.ql();
      }, t)),
      (this.jl = t));
  }
  Fl() {
    null != this.Rl && (clearTimeout(this.Rl), (this.Rl = null));
  }
  initialize() {
    (this.Pl = !1), this.Dl();
  }
  destroy() {
    this.Al.removeAllSubscriptions(),
      this.Go.Rn(),
      this.Fl(),
      (this.Pl = !0),
      this.ql(null, null, !1),
      (this.Rl = null);
  }
  cr(t) {
    return this.Al.ut(t);
  }
  openSession() {
    const t = this.j.ha() !== this.j.mo();
    t && (this.h.ya(o.eu.Jo), this.h.ya(o.eu.su)),
      this.ql(null, !1, null, null, null),
      this.Bn(),
      t &&
        import("./Push/push-manager-factory.js").then(t => {
          if (this.Pl) return;
          const s = t.default.aa();
          if (
            null != s &&
            (dt.isPushPermissionGranted() || dt.isPushBlocked())
          ) {
            const t = () => {
                s.Qr()
                  ? r.D.info(
                      "Push token maintenance is disabled, not refreshing token for backend."
                    )
                  : s.subscribe();
              },
              i = (s, i) => {
                i && t();
              },
              e = () => {
                const s = this.h.I(o.q.vn);
                (null == s || s) && t();
              },
              n = r.xt.Ft;
            new r.qt(n, r.D).hr(n.$t.cu, i, e);
          }
        });
  }
  changeUser(t, s, i) {
    const e = this.v.getUserId();
    if (e !== t) {
      this.j.Bh(),
        null != e && this.ql(null, !1, null, null, null),
        this.v.ru(t),
        i ? this.Go.setSdkAuthenticationSignature(i) : this.Go.On();
      for (let t = 0; t < s.length; t++) s[t].changeUser(null == e);
      null != e && this.h.Xs(o.q.P),
        this.h.Xs(o.q.Xo),
        this.openSession(),
        r.D.info('Changed user to "' + t + '".');
    } else {
      let s = "Doing nothing.";
      i &&
        this.Go.Kn() !== i &&
        (this.Go.setSdkAuthenticationSignature(i),
        (s = "Updated SDK authentication signature")),
        r.D.info(`Current user is already ${t}. ${s}`);
    }
  }
  requestImmediateDataFlush(t) {
    this.Fl(), this.j.mo();
    this.ql(
      null,
      null,
      null,
      null,
      () => {
        r.D.error(
          "Failed to flush data, request will be retried automatically."
        );
      },
      t,
      !0
    );
  }
  requestFeedRefresh() {
    this.j.mo(), this.ql(!0);
  }
  zr(t, s) {
    this.j.mo(),
      r.D.info("Requesting explicit trigger refresh."),
      this.ql(null, !0, null, t, s);
  }
  Nn(t, i) {
    const e = r.A.Ml,
      n = { a: t, l: i },
      l = s.G(e, n);
    return l && r.D.info(`Logged alias ${t} with label ${i}`), l;
  }
  In(i, e, n) {
    if (this.gt.hu(e))
      return (
        r.D.info(`Custom Attribute "${e}" is blocklisted, ignoring.`), new t()
      );
    const l = { key: e, value: n },
      h = s.G(i, l);
    if (h) {
      const t = "object" == typeof n ? JSON.stringify(n, null, 2) : n;
      r.D.info(`Logged custom attribute: ${e} with value: ${t}`);
    }
    return h;
  }
  setLastKnownLocation(t, i, e, n, l, h) {
    const o = { latitude: i, longitude: e };
    null != n && (o.altitude = n),
      null != l && (o.ll_accuracy = l),
      null != h && (o.alt_accuracy = h);
    const u = s.G(r.A.Nl, o, t);
    return (
      u &&
        r.D.info(
          `Set user last known location as ${JSON.stringify(o, null, 2)}`
        ),
      u
    );
  }
  kr(t, s) {
    const i = this.j.mo();
    return new ue(this.v.getUserId(), r.A.Ol, t, i, { cid: s });
  }
  Bn() {
    const t = r.xt.Ft;
    new r.qt(t, r.D).setItem(t.$t.Il, 1, {
      baseUrl: this.Uo,
      data: { api_key: this._r, device_id: this.Ur.te().id },
      userId: this.v.getUserId(),
      sdkAuthEnabled: this.Go.Jn()
    });
  }
  wr(t) {
    for (const s of t)
      if (s.api_key === this._r) this.vt.ca(s.events, s.attributes);
      else {
        const t = r.xt.Ft;
        new r.qt(t, r.D).setItem(t.$t.$r, r.it.nt(), s);
      }
  }
  Tn(i, e, n) {
    if (this.gt.hu(i))
      return (
        r.D.info(`Custom Attribute "${i}" is blocklisted, ignoring.`), new t()
      );
    let l, h;
    return (
      null === e && null === n
        ? ((l = r.A.Ul), (h = { key: i }))
        : ((l = r.A.xl), (h = { key: i, latitude: e, longitude: n })),
      s.G(l, h)
    );
  }
  $n(t, i) {
    const e = { group_id: t, status: i };
    return s.G(r.A.Jl, e);
  }
}
